// extracted by mini-css-extract-plugin
module.exports = {"main":"play-table_main__lmrGH","field":"play-table_field__31s6G","playTable":"play-table_playTable__2u1Ty","selectedCards":"play-table_selectedCards__2OTB8"};